import React from 'react';
import {RouterLocation} from '@store/@types/util/ReactRouter';

interface EmbedParentProps {
  location: RouterLocation;
}

export const EmbedParent: React.FC<EmbedParentProps> = props => {
  return (
    // Embed id is used for overriding styles throughout the app
    <div id="embed-mode">{props.children}</div>
  );
};
